module.exports = __webpack_public_path__ + "static/media/118.f8233dda.png";